// extracted by mini-css-extract-plugin
export default {"mapName":"MapTile_mapName__eMPVP","difficulty":"MapTile_difficulty__d5EHS"};